import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft, Sparkles } from "lucide-react";
import GarageHeroV1 from "@/components/GarageHeroV1";

/**
 * Admin-only Play Garage — the frozen first-cut cartoon garage, kept around
 * for fun / demos / regression comparisons. Do not touch GarageHeroV1.
 * Route: /admin/play-garage
 */
export default function PlayGarage() {
    const navigate = useNavigate();
    return (
        <div className="min-h-screen bg-onyx-900 text-white">
            <Helmet>
                <title>Play Garage · SRT Finder Admin</title>
            </Helmet>

            <div
                className="sticky top-0 z-30"
                style={{
                    background: "rgba(6,6,6,0.92)",
                    borderBottom: "1px solid #262626",
                    backdropFilter: "blur(18px)",
                }}
            >
                <div className="max-w-5xl mx-auto px-4 py-3 flex items-center gap-2">
                    <button
                        onClick={() => navigate(-1)}
                        className="btn-ghost px-2.5 py-2"
                        style={{ borderRadius: 4 }}
                        data-testid="play-garage-back"
                    >
                        <ArrowLeft className="w-4 h-4" />
                    </button>
                    <div className="flex items-center gap-2">
                        <Sparkles className="w-4 h-4 text-hellcat" />
                        <div>
                            <div
                                className="headline text-base leading-none"
                                style={{ letterSpacing: "0.04em" }}
                            >
                                Play Garage
                            </div>
                            <div
                                className="text-[10px] text-onyx-500 mt-1"
                                style={{ letterSpacing: "0.22em" }}
                            >
                                FROZEN BETA v1 · ADMIN SANDBOX
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Frozen v1 hero */}
            <GarageHeroV1 />

            <div className="max-w-3xl mx-auto px-4 py-6 text-sm text-onyx-500 leading-relaxed">
                <p>
                    This is the first cartoon-garage cut, preserved untouched so we can
                    revisit it or demo it later. New iteration lives on the real{" "}
                    <span className="text-white font-semibold">/garage</span> page.
                </p>
            </div>
        </div>
    );
}
